import { Outlet } from 'react-router';

import { SoftwareEscrowContextProvider, SoftwareEscrowOnboardingContextProvider } from 'src/context/software-escrow';
import { SoftwareOnboardingLayout } from 'src/components/SoftwareOnboarding';
import { OnboardingStepSubmitProvider } from 'src/context/onboarding-step-submit';

import Footer from './Footer';
import Header from './Header';

const Layout = () => {
  return (
    <SoftwareEscrowContextProvider>
      <SoftwareEscrowOnboardingContextProvider>
        <OnboardingStepSubmitProvider>
          <SoftwareOnboardingLayout>
            <Header />
            <Outlet />
            <Footer />
          </SoftwareOnboardingLayout>
        </OnboardingStepSubmitProvider>
      </SoftwareEscrowOnboardingContextProvider>
    </SoftwareEscrowContextProvider>
  );
};

export default Layout;
